<template>
  <div class="user-dashboard-container">
    <SideBar class="sidebar" />

    <div class="dashboard-content">
      <div class="maincalendar-content">
        <!-- <SearchBar /> -->

        <div class="title-container">
          <div class="today-title">Your Plan Here!</div>
          <!-- <CurrentDate /> -->
          <SwitchIcon @listClick="goToListPage" :activeButton="'calendar'" />
        </div>

        <CalendarPicker />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/global/SideBar.vue";
// import SearchBar from "@/components/global/SearchBar.vue";
import SwitchIcon from "@/components/plan/SwitchIcon.vue";
import CalendarPicker from "@/components/plan/CalendarPicker.vue";
import { useRouter } from "vue-router";

export default {
  components: {
    SideBar,
    // SearchBar,
    SwitchIcon,
    CalendarPicker,
  },
  setup() {
    const router = useRouter();

    const goToListPage = () => {
      router.push("/plan");
    };

    return { goToListPage };
  },
};
</script>

<style>
.maincalendar-content {
  padding: 20px 40px;
}
</style>
